/* Product carousel, "Shop cards" style: thumbnails swap the image (and price/link for a colour
   variant), Add to cart for single-option products (then opens the cart drawer), progress bar +
   "n / total" counter with prev/next. Handles every .pcs on the page. */
(function () {
  if (window.__pcsInit) return;
  window.__pcsInit = true;

  function openCart() {
    var opener = document.querySelector(".openCartDrawer");
    if (opener && window.jQuery) { opener.click(); return; }
    fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (window.buildCart && window.jQuery) { window.buildCart(cart, false); return; }
        document.querySelectorAll("[data-cart-count]").forEach(function (n) { n.textContent = cart.item_count; });
      }).catch(function () {});
  }

  function setup(root) {
    if (root.dataset.pcsReady) return;
    root.dataset.pcsReady = "1";
    var track = root.querySelector("[data-pcs-track]");
    var cards = Array.prototype.slice.call(track.querySelectorAll("[data-pcs-card]"));
    var prevs = root.querySelectorAll("[data-pcs-prev]"), nexts = root.querySelectorAll("[data-pcs-next]");
    var fill = root.querySelector("[data-pcs-fill]"), count = root.querySelector("[data-pcs-count]");

    function step() {
      var s = cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : 0;
      return s > 0 ? s : (cards[0] && cards[0].offsetWidth) || track.clientWidth || 1;
    }
    function perView() { return Math.max(1, Math.round(track.clientWidth / step())); }
    function atEnd() { return track.scrollLeft + track.clientWidth >= track.scrollWidth - 2; }
    function update() {
      var s = step(), positions = Math.max(1, cards.length - perView() + 1);
      var at = Math.min(positions, Math.round(track.scrollLeft / s) + 1);
      if (count) count.textContent = at + " / " + positions;
      if (fill) fill.style.width = Math.min(100, (track.scrollLeft + track.clientWidth) / track.scrollWidth * 100) + "%";
      root.classList.toggle("is-static", positions <= 1);
    }
    // prev / next loop around at the ends
    function go(dir) {
      if (dir > 0 && atEnd()) track.scrollTo({ left: 0, behavior: "smooth" });
      else if (dir < 0 && track.scrollLeft <= 2) track.scrollTo({ left: track.scrollWidth, behavior: "smooth" });
      else track.scrollBy({ left: dir * step(), behavior: "smooth" });
    }
    Array.prototype.forEach.call(prevs, function (b) { b.addEventListener("click", function () { go(-1); restart(); }); });
    Array.prototype.forEach.call(nexts, function (b) { b.addEventListener("click", function () { go(1); restart(); }); });
    track.addEventListener("scroll", function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener("resize", update);
    window.addEventListener("load", update);
    update();

    // Auto-rotate slowly: one card at a time; pauses while hovered, focused, touched or off screen,
    // and not at all for reduced motion.
    var interval = Math.max(2, parseFloat(root.dataset.interval) || 3.5) * 1000;
    var auto = root.dataset.autoplay === "true" && !(window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches);
    var timer = null, hover = false, focus = false, visible = true, touchedAt = 0;
    function tick() {
      if (hover || focus || !visible || document.hidden || Date.now() - touchedAt < 8000 || root.classList.contains("is-static")) return;
      go(1);
    }
    function restart() { if (!auto) return; clearInterval(timer); timer = setInterval(tick, interval); }
    if (auto) {
      root.addEventListener("mouseenter", function () { hover = true; });
      root.addEventListener("mouseleave", function () { hover = false; });
      root.addEventListener("focusin", function () { focus = true; });
      root.addEventListener("focusout", function () { focus = false; });
      track.addEventListener("touchstart", function () { touchedAt = Date.now(); }, { passive: true });
      track.addEventListener("wheel", function () { touchedAt = Date.now(); }, { passive: true });
      if ("IntersectionObserver" in window) {
        new IntersectionObserver(function (e) { visible = e[0].isIntersecting; }, { threshold: .3 }).observe(root);
      }
      restart();
    }

    cards.forEach(function (card) {
      var img = card.querySelector("[data-pcs-img]");
      var price = card.querySelector("[data-pcs-price]");
      var links = card.querySelectorAll("[data-pcs-link]");
      var base = links.length ? links[0].getAttribute("href").split("?")[0] : null;
      card.querySelectorAll(".pcs__thumb").forEach(function (t) {
        t.addEventListener("click", function () {
          card.querySelectorAll(".pcs__thumb").forEach(function (x) { x.classList.remove("is-active"); });
          t.classList.add("is-active");
          if (img && t.dataset.image) { img.src = t.dataset.image; img.removeAttribute("srcset"); }
          if (price && t.dataset.price) price.textContent = t.dataset.price;
          if (base && t.dataset.variantId) {
            links.forEach(function (a) { a.setAttribute("href", base + "?variant=" + t.dataset.variantId); });
          }
        });
      });
      var add = card.querySelector("[data-pcs-add]");
      if (add) add.addEventListener("click", function () {
        var label = add.textContent;
        var tx = (card.closest("[data-pcs]") || {}).dataset || {};
        add.disabled = true; add.textContent = tx.tAdding || "Adding…";
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
        fetch(root + "cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ items: [{ id: Number(add.dataset.variantId), quantity: 1 }] })
        }).then(function (r) { if (!r.ok) throw r; return r.json(); })
          .then(function () { add.textContent = tx.tAdded || "Added ✓"; openCart(); setTimeout(function () { add.textContent = label; add.disabled = false; }, 2000); })
          .catch(function () { add.textContent = tx.tRetry || "Try again"; add.disabled = false; setTimeout(function () { add.textContent = label; }, 2500); });
      });
    });
  }

  function init() { document.querySelectorAll("[data-pcs]").forEach(setup); }
  // theme editor: re-rendered blocks/sections are new elements
  document.addEventListener("shopify:section:load", init);
  document.addEventListener("shopify:block:select", init);
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
